import { render, staticRenderFns } from "./quiz-contest-info.vue?vue&type=template&id=38232b81&scoped=true&"
import script from "./quiz-contest-info.vue?vue&type=script&lang=js&"
export * from "./quiz-contest-info.vue?vue&type=script&lang=js&"
import style0 from "./quiz-contest-info.vue?vue&type=style&index=0&id=38232b81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38232b81",
  null
  
)

export default component.exports